import { getCookieAmend } from './cookie';
import { registerServiceWorker } from '../services-worker';
import wetvKernel from '@tencent/wetv-kernel';
import { isTestEnv, getAppid } from './util';

const { configInstace, ageisReportor } = wetvKernel;

// kernel包初始化
export function kernelInit() {
  configInstace.proName = 'linux-tv'; // 项目名
  configInstace.cgiEnv = isTestEnv() ? 'test' : 'pro'; // CGI环境，默认正式环境。test：测试，pro：正式
  const { videoAppid, aegisAppid } = getAppid();
  configInstace.aegisMsgAppend = '1.0.24.94';
  configInstace.videoAppid = videoAppid;
  configInstace.aegisAppid = aegisAppid;
  configInstace.platform = '8';
  // 进应用后设置aegis上报时对应的uin用户信息
  const uin = getCookieAmend('vuserid') || '';
  if (uin) {
    ageisReportor?.updateUin({
      vuserid: uin,
      vusession: getCookieAmend('vusession'),
    });
  };
}

// server worker初始化
export function swInit() {
  if (!navigator?.serviceWorker?.controller) {
    registerServiceWorker();
    ageisReportor?.reportEvent({
      name: 'sw_supporter', // 埋点名称
    });
  }
  const reportMatchMessage = JSON.parse(localStorage.getItem('sw_match_cache')) || [];
  const reportAllMessage = JSON.parse(localStorage.getItem('sw_all_cache')) || [];
  navigator?.serviceWorker?.addEventListener('message', (event) => {
    const { data: { all = true } } = event;
    if (all) {
      reportAllMessage.push(event.data);
      localStorage.setItem('sw_all_cache', JSON.stringify(reportAllMessage));
    } else {
      reportMatchMessage.push(event.data);
      localStorage.setItem('sw_match_cache', JSON.stringify(reportMatchMessage));
    }
  });
}
